<template>
  <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
    <div>
      <h3 class="text-slate font-semibold leading-6 text-gray-900">Preview: {{ template.label }}</h3>

      <div class="mt-4">
        <!-- input data -->
        <div class="mb-6">
          <span class="font-bold inline-block mb-2">Input Data:</span>

          <CodeEditor
            v-model="templateInputData"
          />
        </div>



        <div class="mb-4">
          <span class="font-bold mr-2">Subject:</span>
          <span class="text-slate-500">{{ previewSubject }}</span>
        </div>

        <div v-html="previewHTML" />
      </div>
    </div>
  </div>

  <div class="bg-white py-3 flex px-6 justify-end gap-2">
    <BaseButton
      variant="primary"
      text="Close"
      @click="emit('close')"
    />
  </div>
</template>

<script lang="ts" setup>
import BaseButton from '@/components/base/BaseButton.vue'
import { computed, PropType, ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import EmailService, { EmailTemplate } from '@/services/EmailService'
import { find } from 'underscore'
import Handlebars from 'handlebars'
import CodeEditor from '@/components/CodeEditor.vue'

const props = defineProps({
  template: {
    type: Object as PropType<EmailTemplate>,
    required: true
  },
  emailTemplateData: {
    type: Object,
    required: false,
    default: null
  }
})

const emit = defineEmits(['close'])

const emailService = new EmailService()
const templateInputData = ref('{}')

// already fetched in the parent component
const { data: emailTemplates } = useQuery({
  queryKey: ['emailTemplates'],
  queryFn: async () => {
    return await emailService.all() as EmailTemplate[]
  }
})

const previewSubject = computed(() => {
  const data = props.emailTemplateData ?? converToJSON(templateInputData.value)
  return Handlebars.compile(props.template.subject).call(this, data)
})

const previewHTML = computed(() => {
  const baseTempalte = find(emailTemplates.value, (template) => {
    return template.name === 'base_layout'
  }) as EmailTemplate

  const data = props.emailTemplateData ?? converToJSON(templateInputData.value)
  Handlebars.registerPartial(baseTempalte.name, baseTempalte.html)
  return  Handlebars.compile(props.template.html).call(this, data)
})

const converToJSON = (str: string) => {
  try {
    const cleanString = str.trim()
    return JSON.parse(cleanString)
  } catch (err) {
    return str
  }
}

</script>
